import React from "react";
import { Link, NavLink } from "react-router-dom";

import { Box } from "atoms";
import { LinkPrefix } from "utils/constant-data";

export const GetLink = ({
  url,
  children,
  onClick=null,  
  type="normal",
  className="",  
}) => {
  return (
    <>               
      {url?.startsWith("/") ? (
        <>
          {type === "nav" ? <NavLink 
            to={url} 
            onClick={onClick ? onClick : () => {}}
            style={{
              textDecoration: "none",            
            }}            
            className={className}
          >
            {children}
          </NavLink> : <Link
            to={url}
            onClick={onClick ? onClick : () => {}}
            style={{
              textDecoration: "none",            
            }}          
          >
            {children}
          </Link>}
        </>
      ) : LinkPrefix?.some((e) => url?.startsWith(e)) ? (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: "none"
          }}          
        >
          {children}
        </a>
      ) : <Box
        cursor="pointer"
      >
        {children}
      </Box>}
    </>
  )
}